<h1 mat-dialog-title>EBB Retrofit Project</h1>

<div mat-dialog-content class="dialog-content">
  @if (data) {
    <div>
      <h6 class="title">Congratulations!</h6>
      <p>You just accepted a new Seismic Retrofit Project.</p>
      <p>
        Please
        <a routerLink="/contact">contact us</a>
        if you have any questions.
      </p>
    </div>
  } @else {
    <div>
      <p>You have declined this Seismic Retrofit Project.</p>
      <p>
        Please
        <a routerLink="/contact">contact us</a>
        if you have any questions.
      </p>
    </div>
  }
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button type="button" (click)="onClickCancel()">
    Cancel
  </button>

  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="onClickConfirm()">
    Confirm
  </button>
</div>
